<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue'
import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'radix-vue'
import { ChevronDown } from 'lucide-vue-next'
import { cn } from '@/lib/utils'

const props = defineProps<SelectTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        'flex h-10 w-full items-center justify-between rounded-lg border border-stroke-input bg-background-inactive px-3 py-2 focus:outline-hidden focus:ring-ring focus:border-stroke-active text-sm text-white/80 placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:border-stroke-disabled disabled:bg-background-disabled disabled:text-white/20 [&>span]:line-clamp-1 cursor-pointer data-[state=open]:border-stroke-active',
        props.class
      )
    "
  >
    <slot />
    <SelectIcon as-child>
      <ChevronDown class="w-4 h-4" />
    </SelectIcon>
  </SelectTrigger>
</template>
